// extracted by mini-css-extract-plugin
export default {"errorIndicator":"Error-indicator_errorIndicator__X7HlN"};